/**
 * 首页-评模块
 */
import request from '@/api/axios'
import { apiList as api } from './apiList'

// 时间
export function getPadOptionCycle() {
  return request({
    url: api.report.getPadOptionCycle,
    method: 'get',
  })
}

//应用前置检查
export function getPermissionCheck() {
  return request({
    url: api.report.permissionCheck,
    method: 'get',
  })
}

// 获取用户信息
export function getUserInfos() {
  return request({
    url: api.report.userInfo,
    method: 'get',
  })
}

// 查询可选择的班级
export function getProjectList() {
  return request({
    url: api.report.getProjectList,
    method: 'get',
  })
}

//个人验收报告
export function getAcceptInfo(data) {
  return request({
    url: api.report.acceptInfo,
    method: 'post',
    data,
  })
}
/**
 * 验收报告【达标验收】
 * @param {*} data
 * @returns
 */
export function getAcceptReport(data) {
  return request({
    url: api.report.acceptReport,
    method: 'post',
    data,
  })
}

/**
 * 删除评价
 * @returns
 */
export function deleteExecute(id) {
  return request({
    url: api.report.deleteExecute + id + '/1',
    method: 'delete',
  })
}
/**
 * 验收报告【验收详情】
 * @param {*} data
 * @returns
 */
export function getAcceptView(data) {
  return request({
    url: api.report.acceptView,
    method: 'post',
    data,
  })
}

/**
 * 提交验收
 * @param {*} data
 * @returns
 */
export function putEvaluateSubmit(data) {
  return request({
    url: api.report.evaluateSubmit,
    method: 'put',
    data,
  })
}
/**
 * 验收总览
 */
export function evaPersonalOverview(data) {
  return request({
    url: api.report.acceptOverview,
    method: 'post',
    data,
  })
}

// 切换班级
export function setSwitchClasses(data) {
  return request({
    url: api.report.switchClasses,
    method: 'post',
    data,
  })
}
